/*
 * Copyright (C) Zoomdata, Inc. 2012-2022. All rights reserved.
 */
import { initializeEmbedBundlesRegistry } from './EmbedBundlesRegistry';
import { EmbedEventNames, EMBED_CUSTOM_EVENT, } from './types';
export const wait = (timeout) => {
    return new Promise((res) => {
        setTimeout(res, timeout);
    });
};
export const generateUUID = () => {
    return 'xxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0; // eslint-disable-line no-bitwise
        const v = c === 'x' ? r : (r & 0x3) | 0x8; // eslint-disable-line no-bitwise
        return v.toString(16);
    });
};
export const createPageData = async (context) => {
    const { serverPath, params: { token }, } = context;
    const response = await fetch(`${serverPath}/api/version`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
        const initFailedEvent = new CustomEvent(EmbedEventNames.FAILED);
        document.dispatchEvent(initFailedEvent);
        return Promise.reject(response);
    }
    const version = await response.json();
    return { staticResourceVersion: version.git, version: version.version };
};
export const getDashboardsByOriginId = async (context, originId) => {
    const { serverPath, params: { token }, } = context;
    const response = await fetch(`${serverPath}/api/dashboards?filter=originId='${originId}'`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
        return Promise.reject(response);
    }
    const dashboards = await response.json();
    return dashboards;
};
export const decoratePageData = (config) => {
    const { host, params: { embed, token }, pageData, path, port, secure, url, } = config;
    config.pageData.context = { host, path, port, secure };
    config.pageData.user = pageData.user || {};
    config.pageData.user.access_token = token;
    config.pageData.embed = embed || 'script';
    config.pageData.contextPath = url;
};
export const loadScriptBundle = async (context, bundleName) => {
    const { pageData: { staticResourceVersion }, params: { token }, serverPath, nonce, } = context;
    initializeEmbedBundlesRegistry(window);
    const scriptURL = new URL(`${serverPath}/${bundleName}`);
    scriptURL.searchParams.append('v', staticResourceVersion);
    const scriptURLString = scriptURL.toString();
    const existing = window.__logi__.embedBundles.get(bundleName);
    if (existing) {
        return await existing;
    }
    window.__logi__.embedBundles.initialize(bundleName);
    const scriptSource = fetch(scriptURLString, {
        headers: { Authorization: `Bearer ${token}` },
    }).then((response) => response.text());
    window.__logi__.embedBundles.register(bundleName, scriptSource);
    const bundleScriptElement = document.createElement('script');
    if (nonce) {
        bundleScriptElement.nonce = nonce;
    }
    bundleScriptElement.text = `${await scriptSource}
//# sourceURL=${bundleName}`;
    document.body.appendChild(bundleScriptElement);
};
const createEvent = (type, detail, cancelBubble) => {
    return new CustomEvent(type, {
        detail,
        bubbles: !cancelBubble,
    });
};
export const dispatchEmbedCustomEvent = (type, data) => {
    const publishEvent = createEvent(EMBED_CUSTOM_EVENT, { type, data });
    document.dispatchEvent(publishEvent);
};
export function resolveHTMLElement(element) {
    if (typeof element !== 'string' && !(element instanceof HTMLElement)) {
        throw TypeError('Invalid type provided for `modalContainer` setting. Expected a string or an instance of HTMLElement');
    }
    const resolvedHTMLElement = typeof element === 'string' ? document.querySelector(element) : element;
    if (!(resolvedHTMLElement instanceof HTMLElement)) {
        throw Error('The provided selector for the `modalContainer` did not resolve to an HTMLElement on the page');
    }
    return resolvedHTMLElement;
}
export function convertToURLParameters(variables) {
    const urlParameters = [];
    let key;
    let value;
    for (key in variables) {
        if (variables.hasOwnProperty(key)) {
            value = variables[key];
            if (value !== undefined && value !== '' && value !== null) {
                urlParameters.push(key + '=' + encodeURIComponent(value));
            }
        }
    }
    return urlParameters.join('&');
}
//# sourceMappingURL=utilities.js.map